import { ADDITIONAL_CONTENT_CONTAINER } from 'Constant';

/**
 * Displays/hides the additional contents' container div-s
 * specified in Additional_Contents property in gigakombi-offers JSON file
 * @param footnote
 */
export const renderAdditionalContents = (currentOffers): void => {

    const parentContainer = document.getElementById(ADDITIONAL_CONTENT_CONTAINER);

    if (!parentContainer?.hasChildNodes()) {
        return;
    }

    const additionalContContainers = parentContainer.children as HTMLCollectionOf<HTMLDivElement>;

    // Collect all additional content containers to be shown
    const containerIdsToShow = [];
    currentOffers.forEach(offer => {
        const newAdditionalContentCandidates = offer.Additional_Contents.split(',');
        const newItems = newAdditionalContentCandidates.filter(item => !containerIdsToShow.includes(item));
        containerIdsToShow.push(...newItems);
    });

    for (let i = 0; i < additionalContContainers.length; i++) {
        const additionalContContainer = additionalContContainers[i];
        additionalContContainer.classList.toggle('brix-is-hidden', !containerIdsToShow.includes(additionalContContainer.id));
    }
};
